import { PROJECT_THEME } from "../theme";

type LinkProps =
  | {
      url: string;
      scrollTo?: never;
      style?: React.CSSProperties;
    }
  | {
      url?: never;
      scrollTo: React.RefObject<HTMLElement>;
      style?: React.CSSProperties;
    };

export default function Link(props: LinkProps) {
  return (
    <a
      href={props.url}
      onClick={(e) => {
        if (props.scrollTo) {
            console.log("Scrolling to", props.scrollTo.current);
          e.preventDefault();

          const topOfRfp = props.scrollTo.current?.getBoundingClientRect().top

          
                  window.scrollTo({
                      top: topOfRfp ? topOfRfp - PROJECT_THEME.dimensions.NAVBAR_HEIGHT + window.scrollY: undefined,
                      behavior: 'smooth'
                  }) 
        }
      }}
      style={{
        cursor: "pointer",
        ...props.style,
      }}
    >
      <img
        src="/assets/img/link.svg"
        alt="link icon"
        style={{
          cursor: "pointer",
        }}
      />
    </a>
  );
}